export enum WebSocketMessageTypeOutgoing {
        WsDeviceUpdate,
        WsEspControlPower,
        WsEspControlReset,
        WsRequestTransputStates
}
